/** Coarse-pointer + touch-capable devices (phones/tablets) - used to pick a
 * cheaper renderer tier and to decide whether to show the on-screen
 * joystick/action buttons instead of relying on keyboard input. */
export function isTouchDevice() {
  if (typeof window === "undefined") return false;
  const coarsePointer = window.matchMedia?.("(pointer: coarse)").matches ?? false;
  const hasTouch = navigator.maxTouchPoints > 0 || "ontouchstart" in window;
  return coarsePointer && hasTouch;
}
